import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {browserHistory} from 'react-router'
import showToastr from '../../utils/showToastr'

class UserActive extends Component {
  constructor (props) {
    super(props)

    Actions.userActive({key: this.props.location.query.key}).then(res => {
      showToastr('success', 'تایید اکانت', res.data.messages[0])
      browserHistory.push('/login')
    }).catch((err) => {
      showToastr('error', 'تایید اکانت', err.response.data.errors[0])
      browserHistory.push('/')
    })
  }

  render () {
    return (
      <div />
    )
  }
}

export default UserActive



// WEBPACK FOOTER //
// ./src/components/UserActive/UserActive.js